export default "__VITE_ASSET__CrYCkCmN__"